const EventEmitter = {
  events: {}, // dictionary with our events
  on(event, listener) {
    // add event listeners
    if (!this.events[event]) {
      this.events[event] = { listeners: [] };
    }
    this.events[event].listeners.push(listener);
  },
  off(event, listener) {
    // remove listeners
    if (!listener) {
      delete this.events[event];
      return;
    }

    const eventObject = this.events[event];
    if (!eventObject) return;
    const { listeners } = eventObject;
    const index = listeners.indexOf(listener);
    if (index > -1) listeners.splice(index, 1);
  },
  emit(name, ...payload) {
    // trigger events
    if (!this.events[name]) {
      return;
    }
    for (const listener of this.events[name].listeners) {
      listener.apply(this, payload);
    }
  },
};

export const EVENTS = {
  // floor item
  FLOOR_ITEM_UPDATED: 'floor_item_updated',
  // admin logout event
  ADMIN_LOGOUT: 'admin_logout',
  START_DOWNLOADING_QR_CODES: 'start_downloading_qr_codes',
  END_DOWNLOADING_QR_CODES: 'end_downloading_qr_codes',
  LOADING_MONTHLY_STATEMENT_DATA: 'loading_monthly_statement_data',
  LOADED_MONTHLY_STATEMENT_DATA: 'loaded_monthly_statement_data',
  START_DOWNLOADING_MONTHLY_STATEMENT: 'start_downloading_monthly_statement',
  END_DOWNLOADED_MONTHLY_STATEMENT: 'end_downloaded_monthly_statement',
  SALES_BREAKDOWN_FILTER_CHANGED: 'sales_breakdown_filter_changed',
  TABLE_COLUMNS_CHANGED: 'table_columns_changed',
  ADD_QUICK_NOTES: 'add_quick_notes',
  ADD_ALTERNATIVE_PAYMENTS: 'add_alternative_payments',
  FLOOR_PLAN_SHAPE_SELECTION_CHANGED: 'floor_plan_shape_selection_changed',
  FLOOR_PLAN_SHAPES_MOVED: 'floor_plan_shapes_moved',
  FLOOR_PLAN_SHAPES_CHANGED: 'floor_plan_shapes_changed',
  LOADING_PAYOUT_REPORT_DATA: 'loading_payout_report_data',
  LOADED_PAYOUT_REPORT_DATA: 'loaded_payout_report_data',
  HANDLING_PHOTOT: 'handling_photo',
  HANDLED_PHOTO: 'handled_photo',
  MENU_SCROLL: 'menu_scroll',
};

export default EventEmitter;
